import {
  Bed, Hotel, Plane, Ticket, Mountain, Calendar, FileSpreadsheet,
  Users, MapPin, Printer, ArrowBigRight, Clock, PlaneLanding, Package,
  PlaneTakeoff, Car, Navigation, CarFront, Building2, Info, X, CheckCircle
} from "lucide-react";


export const HotelSection = ({ booking, t, styles }) => {
  const product = booking.product;
  const hotel = booking.booking_hotel;

  // Calcul du total des occupants
  const totalOccupants = (hotel?.adult_count || 0) + (hotel?.child_count || 0);

  // Format du prix
  const formatPrice = (price) => {
    if (!price) return '0.00';
    return parseFloat(price).toLocaleString();
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '8px',
      padding: '20px',
      border: '1px solid #e5e7eb',
      marginTop: '0'
    }}>
      <h2 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        margin: '0 0 20px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <Hotel size={18} color="#7c3aed" />
        {t('hotelInformation')}
      </h2>

      {/* Informations sur l'hôtel */}
      {product && (
        <div style={{
          background: '#f8fafc',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '20px',
          border: '1px solid #e5e7eb'
        }}>
          <h3 style={{
            fontSize: '15px',
            fontWeight: '600',
            color: '#374151',
            margin: '0 0 12px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Building2 size={16} color="#7c3aed" />
            {t('hotelDetails')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
            gap: '12px'
          }}>
            {product.name && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('hotelName')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.name}
                </div>
              </div>
            )}

            {product.address && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('address')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.address}
                </div>
              </div>
            )}

            {product.phone && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('phone')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.phone}
                </div>
              </div>
            )}

            {product.country?.name && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('country')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.country.name}
                </div>
              </div>
            )}

            {product.city?.name && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('city')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.city.name}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Section dates et durée */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px',
        marginBottom: '24px'
      }}>
        {/* Carte Check-in / Check-out */}
        <div style={{
          background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
          borderRadius: '10px',
          padding: '20px',
          border: '1px solid #7dd3fc'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#0369a1',
            margin: '0 0 16px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Calendar size={16} />
            {t('dates')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '12px'
          }}>
            {/* Check-in */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('checkin')}
              </div>
              <div style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#10b981',
                lineHeight: '1'
              }}>
                {booking.checkin ? new Date(booking.checkin).toLocaleDateString() : 'N/A'}
              </div>
            </div>

            {/* Check-out */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('checkout')}
              </div>
              <div style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#ef4444',
                lineHeight: '1'
              }}>
                {booking.checkout ? new Date(booking.checkout).toLocaleDateString() : 'N/A'}
              </div>
            </div>

            {/* Nuits */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('nights')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#8b5cf6',
                lineHeight: '1'
              }}>
                {hotel?.nights || 0}
              </div>
            </div>

            {/* Durée */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('duration')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#f59e0b',
                lineHeight: '1'
              }}>
                {booking.duration || 0}
              </div>
            </div>
          </div>
        </div>

        {/* Carte occupants et repas */}
        <div style={{
          background: 'linear-gradient(135deg, #f5f3ff 0%, #f7f3ff 100%)',
          borderRadius: '10px',
          padding: '20px',
          border: '1px solid #f0abfc'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#86198f',
            margin: '0 0 16px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Users size={16} />
            {t('occupancyAndMeal')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '12px',
            marginBottom: '16px'
          }}>
            {/* Adults */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('adults')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#10b981',
                lineHeight: '1'
              }}>
                {hotel?.adult_count || 0}
              </div>
            </div>

            {/* Children */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('children')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#f59e0b',
                lineHeight: '1'
              }}>
                {hotel?.child_count || 0}
              </div>
            </div>

            {/* Rooms */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('rooms')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#3b82f6',
                lineHeight: '1'
              }}>
                {hotel?.rooms_count || 0}
              </div>
            </div>

            {/* Total Occupants */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('totalOccupants')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#8b5cf6',
                lineHeight: '1'
              }}>
                {totalOccupants}
              </div>
            </div>
          </div>

          {/* Plan de repas */}
          {hotel?.meal_name && (
            <div style={{
              marginTop: '12px',
              padding: '12px',
              background: 'white',
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                {t('mealPlan')}
              </div>
              <div style={{
                fontSize: '16px',
                fontWeight: '600',
                color: '#10b981'
              }}>
                {hotel.meal_name}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Détails des chambres */}
      {hotel?.rooms && hotel.rooms.length > 0 && (
        <div style={{ marginBottom: '24px' }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1f2937',
            margin: '0 0 16px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Bed size={16} color="#7c3aed" />
            {t('roomDetails')} ({hotel.rooms.length})
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '16px'
          }}>
            {hotel.rooms.map((room, index) => (
              <div key={index} style={{
                background: '#f9fafb',
                borderRadius: '10px',
                padding: '16px',
                border: '1px solid #e5e7eb',
                transition: 'transform 0.2s ease',
                ':hover': {
                  transform: 'translateY(-2px)'
                }
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  marginBottom: '5px'
                }}>
                  <div>
                    <div style={{
                      fontSize: '15px',
                      fontWeight: '600',
                      color: '#1f2937',
                      marginBottom: '4px'
                    }}>
                      {room.name || `${t('room')} ${index + 1}`}
                    </div>

                  </div>
                  <div style={{
                    fontSize: '11px',
                    color: '#6b7280',
                    background: '#f3f4f6',
                    padding: '4px 8px',
                    borderRadius: '12px'
                  }}>
                    {room.count || 1} {t('rooms')}
                  </div>
                </div>

                {room.bed_type && (
                  <div style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '5px',
                    gap: '4px'
                  }}>
                    <Bed size={14} />
                    {room.bed_type}
                  </div>
                )}

                {/* Détails de la chambre */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(2, 1fr)',
                  gap: '8px',
                  marginBottom: '12px'
                }}>
                  <div>
                    <div style={{ fontSize: '11px', color: '#6b7280' }}>
                      {t('adults')}
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#10b981' }}>
                      {room.adult || 0}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: '11px', color: '#6b7280' }}>
                      {t('children')}
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#f59e0b' }}>
                      {room.child || 0}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: '11px', color: '#6b7280' }}>
                      {t('price')}
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#8b5cf6' }}>
                      {formatPrice(room.amount)} {booking.currency}
                    </div>
                  </div>

                  <div>
                    <div style={{ fontSize: '11px', color: '#6b7280' }}>
                      {t('providerPrice')}
                    </div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#3b82f6' }}>
                      {formatPrice(room.amount_provider)} {booking.provider_currency}
                    </div>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>
      )}

      {/* Commentaires sur le tarif */}
      {booking.policies && booking.policies.length > 0 && (
        <div style={{
          background: '#fffbeb',
          borderRadius: '8px',
          padding: '16px',
          border: '1px solid #fde68a'
        }}>
          <h3 style={{
            fontSize: '15px',
            fontWeight: '600',
            color: '#92400e',
            margin: '0 0 12px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Info size={16} color="#f59e0b" />
            {t('rateComments')}
          </h3>
          {booking.policies.map((policy, index) => (
            <p key={index} style={{
              fontSize: '13px',
              color: '#92400e',
              margin: '8px 0',
              lineHeight: '1.5'
            }}>
              {policy.value}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
export const FlightSection = ({ booking, t, styles }) => {
  const flight = booking.booking_flight || booking.flight;
  const itineraries = flight?.itineraries || flight?.itinerary || [];

  if (!flight) return null;

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '24px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      marginTop: '0'
    }}>
      {/* En-tête avec statut du vol */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white'
          }}>
            <Plane size={24} />
          </div>
          <div>
            <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1f2937',
              margin: '0 0 4px 0'
            }}>
              {t('flightDetails')}
            </h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{
                fontSize: '13px',
                color: '#6b7280',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <Calendar size={12} />
                {flight.trip === 'Roudtrip' ? t('roundTrip') : t('oneWay')}
              </span>
              {flight.airline && (
                <span style={{
                  fontSize: '13px',
                  color: '#7c3aed',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                  <Plane size={12} />
                  {flight.airline.name} ({flight.airline.code})
                </span>
              )}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button style={{
            ...styles.outlineButton,
            padding: '10px 16px',
            fontSize: '14px'
          }}>
            <Ticket size={16} />
            {t('viewTicket')}
          </button>
          <button style={{
            ...styles.primaryButton,
            padding: '10px 20px',
            fontSize: '14px'
          }}>
            <FileSpreadsheet size={16} />
            {t('printItinerary')}
          </button>
        </div>
      </div>

      {/* Section 1: Statistiques des passagers */}
      <div style={{
        background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
        borderRadius: '10px',
        padding: '20px',
        marginBottom: '24px',
        border: '1px solid #ddd6fe'
      }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#7c3aed',
          margin: '0 0 16px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <Users size={16} />
          {t('passengerSummary')}
        </h3>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '16px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
              {t('adults')}
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#7c3aed',
              lineHeight: '1'
            }}>
              {flight.adult || 0}
            </div>

          </div>

          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
              {t('children')}
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f59e0b',
              lineHeight: '1'
            }}>
              {flight.child || 0}
            </div>
          </div>

          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
              {t('infants')}
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#3b82f6',
              lineHeight: '1'
            }}>
              {flight.infant || 0}
            </div>
          </div>

          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
              {t('totalPassengers')}
            </div>
            <div style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#10b981',
              lineHeight: '1'
            }}>
              {(flight.adult || 0) + (flight.child || 0) + (flight.infant || 0)}
            </div>
          </div>
        </div>
      </div>

      {/* Section 2: Itinéraires détaillés */}
      {itineraries.length > 0 && (
        <div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1f2937',
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <MapPin size={18} color="#7c3aed" />
              {t('flightItineraries')}
              <span style={{
                fontSize: '14px',
                color: '#6b7280',
                fontWeight: 'normal',
                marginLeft: '8px'
              }}>
                ({itineraries.length})
              </span>
            </h3>

            <div style={{ display: 'flex', gap: '8px' }}>
              <button style={{
                ...styles.outlineButton,
                fontSize: '12px',
                padding: '6px 12px'
              }}>
                <Calendar size={12} />
                {t('addToCalendar')}
              </button>
              <button style={{
                ...styles.outlineButton,
                fontSize: '12px',
                padding: '6px 12px'
              }}>
                <Printer size={12} />
                {t('print')}
              </button>
            </div>
          </div>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}>
            {itineraries.map((itinerary, index) => {
              const segment = itinerary.segments?.[0];

              return (
                <div key={index} style={{
                  background: 'white',
                  borderRadius: '12px',
                  border: '1px solid #e5e7eb',
                  overflow: 'hidden',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  transition: 'all 0.2s ease',
                  ':hover': {
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    borderColor: '#d1d5db'
                  }
                }}>
                  {/* En-tête de l'itinéraire */}
                  <div style={{
                    background: index % 2 === 0 ? '#f0fdf4' : '#f5f3ff',
                    padding: '16px 20px',
                    borderBottom: '1px solid #e5e7eb',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '8px',
                        background: index % 2 === 0 ? '#dcfce7' : '#ede9fe',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: index % 2 === 0 ? '#10b981' : '#7c3aed',
                        fontSize: '14px',
                        fontWeight: '600'
                      }}>
                        {index === 0 ? <PlaneTakeoff /> : <PlaneLanding />}
                      </div>
                      <div>
                        <div style={{ fontSize: '15px', fontWeight: '600', color: '#1f2937' }}>
                          {index === 0 ? t('outbound') : t('return')}
                        </div>
                        <div style={{ fontSize: '13px', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span>{itinerary.departure?.name} ({itinerary.departure?.code})</span>
                          <ArrowBigRight size={12} color="#9ca3af" />
                          <span>{itinerary.arrival?.name} ({itinerary.arrival?.code})</span>
                        </div>
                      </div>
                    </div>
                    <div style={{
                      fontSize: '13px',
                      color: '#6b7280',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}>
                      <Clock size={12} />
                      {segment?.duration || 'N/A'}
                    </div>
                  </div>

                  {/* Corps de l'itinéraire */}
                  <div style={{ padding: '20px' }}>
                    {/* Vol principal */}
                    {segment && (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '16px',
                        background: '#f9fafb',
                        borderRadius: '10px',
                        marginBottom: '16px',
                        border: '1px solid #e5e7eb'
                      }}>
                        {/* Départ */}
                        <div style={{ flex: 1, textAlign: 'center' }}>
                          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#7c3aed' }}>
                            {segment.departure?.code || 'N/A'}
                          </div>
                          <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
                            {segment.departure?.name || ''}
                          </div>
                          <div style={{ fontSize: '15px', fontWeight: '600', color: '#1f2937', marginTop: '8px' }}>
                            {segment.departure?.date ? new Date(segment.departure.date).toLocaleTimeString([], {
                              hour: '2-digit',
                              minute: '2-digit'
                            }) : ''}
                          </div>
                          <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                            {segment.departure?.date ? new Date(segment.departure.date).toLocaleDateString() : ''}
                          </div>
                          {segment.departure?.terminal && (
                            <div style={{
                              fontSize: '11px',
                              color: '#7c3aed',
                              background: 'rgba(124, 58, 237, 0.1)',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              marginTop: '6px',
                              display: 'inline-block'
                            }}>
                              Terminal {segment.departure.terminal}
                            </div>
                          )}
                        </div>

                        {/* Ligne de vol */}
                        <div style={{ flex: 2, padding: '0 20px', position: 'relative' }}>
                          <div style={{
                            height: '2px',
                            background: 'linear-gradient(90deg, #7c3aed 0%, #6d28d9 100%)',
                            width: '100%',
                            position: 'relative'
                          }}>
                            <Plane size={18} style={{
                              position: 'absolute',
                              top: '-8px',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              color: '#7c3aed',
                              animation: 'fly 2s ease-in-out infinite'
                            }} />
                          </div>
                          <div style={{ textAlign: 'center', marginTop: '12px' }}>
                            <div style={{
                              fontSize: '13px',
                              fontWeight: '600',
                              color: '#7c3aed',
                              background: 'white',
                              padding: '4px 12px',
                              borderRadius: '20px',
                              display: 'inline-block',
                              border: '1px solid #ddd6fe'
                            }}>
                              {segment.flightNumber || 'N/A'}
                            </div>
                            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px' }}>
                              {segment.airline?.name || ''}
                            </div>
                            <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>
                              {segment.duration || ''}
                            </div>
                          </div>
                        </div>

                        {/* Arrivée */}
                        <div style={{ flex: 1, textAlign: 'center' }}>
                          <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#7c3aed' }}>
                            {segment.arrival?.code || 'N/A'}
                          </div>
                          <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '4px' }}>
                            {segment.arrival?.name || ''}
                          </div>
                          <div style={{ fontSize: '15px', fontWeight: '600', color: '#1f2937', marginTop: '8px' }}>
                            {segment.arrival?.date ? new Date(segment.arrival.date).toLocaleTimeString([], {
                              hour: '2-digit',
                              minute: '2-digit'
                            }) : ''}
                          </div>
                          <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                            {segment.arrival?.date ? new Date(segment.arrival.date).toLocaleDateString() : ''}
                          </div>
                          {segment.arrival?.terminal && (
                            <div style={{
                              fontSize: '11px',
                              color: '#10b981',
                              background: 'rgba(16, 185, 129, 0.1)',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              marginTop: '6px',
                              display: 'inline-block'
                            }}>
                              Terminal {segment.arrival.terminal}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Détails supplémentaires */}
                    <div style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                      gap: '12px',
                      marginTop: '16px'
                    }}>
                      <div style={{
                        background: '#f9fafb',
                        borderRadius: '8px',
                        padding: '12px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                          {t('airline')}
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                          {segment?.airline?.name || flight.airline?.name || 'N/A'}
                        </div>
                      </div>

                      <div style={{
                        background: '#f9fafb',
                        borderRadius: '8px',
                        padding: '12px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                          {t('flightNumber')}
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#7c3aed' }}>
                          {segment?.flightNumber || 'N/A'}
                        </div>
                      </div>

                      <div style={{
                        background: '#f9fafb',
                        borderRadius: '8px',
                        padding: '12px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                          {t('duration')}
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#10b981' }}>
                          {segment?.duration || 'N/A'}
                        </div>
                      </div>

                      <div style={{
                        background: '#f9fafb',
                        borderRadius: '8px',
                        padding: '12px',
                        border: '1px solid #e5e7eb'
                      }}>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                          {t('date')}
                        </div>
                        <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                          {segment?.departure?.date ? new Date(segment.departure.date).toLocaleDateString() : 'N/A'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export const ActivitySection = ({ booking, t, styles }) => {
  const activity = booking.activity || booking.booking_activity;
  const product = booking.product;

  // Calcul du total des passagers
  const totalPassengers = (activity?.adult || 0) + (activity?.child || 0) + (activity?.baby || 0) + (activity?.senior || 0);

  // Format du prix
  const formatPrice = (price) => {
    if (!price) return '0.00';
    return parseFloat(price).toFixed(2);
  };

  return (
    <div style={{
      background: 'white',
      borderRadius: '8px',
      padding: '20px',
      border: '1px solid #e5e7eb',
      marginTop: '0'
    }}>
      <h2 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        margin: '0 0 20px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <Mountain size={18} color="#7c3aed" />
        {t('activityDetails')}
      </h2>

      {/* Informations sur le produit */}
      {product && (
        <div style={{
          background: '#f8fafc',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '20px',
          border: '1px solid #e5e7eb'
        }}>
          <h3 style={{
            fontSize: '15px',
            fontWeight: '600',
            color: '#374151',
            margin: '0 0 12px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Package size={16} color="#7c3aed" />
            {t('activityInformation')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '12px'
          }}>
            {product.name && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('activityName')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.name}
                </div>
              </div>
            )}

            {product.address && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('location')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.address}
                </div>
              </div>
            )}

            {product.phone && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('contactPhone')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.phone}
                </div>
              </div>
            )}

            {product.country?.name && (
              <div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                  {t('country')}
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#1f2937' }}>
                  {product.country.name}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Section prix et passagers */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: '20px',
        marginBottom: '24px'
      }}>
        {/* Cartes des passagers */}
        <div style={{
          background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
          borderRadius: '10px',
          padding: '20px',
          border: '1px solid #bbf7d0'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#059669',
            margin: '0 0 16px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Users size={16} />
            {t('passengerBreakdown')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '12px'
          }}>
            {/* Adults */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('adults')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#10b981',
                lineHeight: '1'
              }}>
                {activity?.adult || 0}
              </div>
            </div>

            {/* Children */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('children')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#f59e0b',
                lineHeight: '1'
              }}>
                {activity?.child || 0}
              </div>
            </div>

            {/* Babies */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('babies')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#8b5cf6',
                lineHeight: '1'
              }}>
                {activity?.baby || 0}
              </div>
            </div>

            {/* Seniors */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('seniors')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#3b82f6',
                lineHeight: '1'
              }}>
                {activity?.senior || 0}
              </div>
            </div>
          </div>

          {/* Total */}
          <div style={{
            marginTop: '16px',
            paddingTop: '16px',
            borderTop: '2px solid #bbf7d0',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '4px' }}>
              {t('totalPassengers')}
            </div>
            <div style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#059669',
              lineHeight: '1'
            }}>
              {totalPassengers}
            </div>
          </div>
        </div>

        {/* Section prix et durée */}
        <div style={{
          background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
          borderRadius: '10px',
          padding: '20px',
          border: '1px solid #93c5fd'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1d4ed8',
            margin: '0 0 16px 0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Calendar size={16} />
            {t('durationAndPrice')}
          </h3>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '16px',
            marginBottom: '16px'
          }}>
            {/* Days */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('days')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#3b82f6',
                lineHeight: '1'
              }}>
                {activity?.days || 0}
              </div>
            </div>

            {/* Amount */}
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('activityPrice')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#10b981',
                lineHeight: '1'
              }}>
                {formatPrice(activity?.amount)} {booking?.currency || 'EUR'}
              </div>
            </div>
          </div>

          {/* Prix détaillés */}
          {activity?.prices && activity.prices.length > 0 && (
            <div style={{
              marginTop: '16px',
              padding: '12px',
              background: 'white',
              borderRadius: '6px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '8px' }}>
                {t('detailedPrices')}
              </div>
              <div style={{ fontSize: '12px', color: '#6b7280' }}>
                {activity.prices.map((price, index) => (
                  <div key={index} style={{ padding: '4px 0', borderBottom: '1px solid #f3f4f6' }}>
                    {price.description || t('priceItem')} {index + 1}: {formatPrice(price.amount)} {booking?.currency || 'EUR'}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Message si pas de prix détaillés */}
      {(!activity?.prices || activity.prices.length === 0) && (
        <div style={{
          background: '#fef3c7',
          borderRadius: '6px',
          padding: '12px',
          textAlign: 'center',
          border: '1px solid #fcd34d'
        }}>
          <div style={{ fontSize: '13px', color: '#92400e' }}>
            {t('noDetailedPrices')}
          </div>
        </div>
      )}
    </div>
  );
};

export const TransferSection = ({ booking, t, styles }) => {
  const transfer = booking.transfer || booking.booking_transfer;
  const itineraries = transfer?.itineraries || [];

  if (!transfer) return null;

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '24px',
      border: '1px solid #e5e7eb',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      marginTop: '20px'
    }}>
      {/* En-tête avec type de transfert */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white'
          }}>
            <Car size={24} />
          </div>
          <div>
            <h2 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1f2937',
              margin: '0 0 4px 0'
            }}>
              {t('transferDetails')}
            </h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{
                fontSize: '13px',
                color: '#6b7280',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <Navigation size={12} />
                {transfer.type?.trim() === 'Oneway' ? t('oneWayTransfer') : t('roundTripTransfer')}
              </span>
              {transfer.travelType && (
                <span style={{
                  fontSize: '13px',
                  color: '#3b82f6',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                  <Plane size={12} />
                  {t('forFlight')}: {transfer.travelNumber || 'N/A'}
                </span>
              )}
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button style={{
            ...styles.outlineButton,
            padding: '10px 16px',
            fontSize: '14px'
          }}>
            <MapPin size={16} />
            {t('viewRoute')}
          </button>
          <button style={{
            ...styles.primaryButton,
            padding: '10px 20px',
            fontSize: '14px'
          }}>
            <Car size={16} />
            {t('contactDriver')}
          </button>
        </div>
      </div>

      {/* Section 1: Statistiques des passagers */}
      <div style={{
        background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
        borderRadius: '10px',
        padding: '20px',
        marginBottom: '24px',
        border: '1px solid #bbf7d0'
      }}>
        <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#059669',
          margin: '0 0 16px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <Users size={16} />
          {t('passengerCapacity')}
        </h3>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '16px'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
              {t('adults')}
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#10b981',
              lineHeight: '1'
            }}>
              {transfer.adult || 0}
            </div>
          </div>

          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
              {t('children')}
            </div>
            <div style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#f59e0b',
              lineHeight: '1'
            }}>
              {transfer.child || 0}
            </div>
          </div>

          <div style={{
            background: 'white',
            borderRadius: '8px',
            padding: '16px',
            textAlign: 'center',
            border: '1px solid #e5e7eb',
            boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
          }}>
            <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
              {t('totalPassengers')}
            </div>
            <div style={{
              fontSize: '28px',
              fontWeight: 'bold',
              color: '#059669',
              lineHeight: '1'
            }}>
              {(transfer.adult || 0) + (transfer.child || 0)}
            </div>
          </div>

          {itineraries[0]?.vehicle && (
            <div style={{
              background: 'white',
              borderRadius: '8px',
              padding: '16px',
              textAlign: 'center',
              border: '1px solid #e5e7eb',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
            }}>
              <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '8px' }}>
                {t('vehicleCapacity')}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#3b82f6',
                lineHeight: '1'
              }}>
                {itineraries[0].vehicle.capacity || 0}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Section 2: Itinéraires de transfert */}
      {itineraries.length > 0 && (
        <div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#1f2937',
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
              <MapPin size={18} color="#059669" />
              {t('transferItinerary')}
              <span style={{
                fontSize: '14px',
                color: '#6b7280',
                fontWeight: 'normal',
                marginLeft: '8px'
              }}>
                ({itineraries.length})
              </span>
            </h3>

            {/* <div style={{ display: 'flex', gap: '8px' }}>
              <button style={{
                ...styles.outlineButton,
                fontSize: '12px',
                padding: '6px 12px'
              }}>
                <Clock size={12} />
                {t('updateTime')}
              </button>
              <button style={{
                ...styles.outlineButton,
                fontSize: '12px',
                padding: '6px 12px'
              }}>
                <Info size={12} />
                {t('details')}
              </button>
            </div> */}
          </div>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}>
            {itineraries.map((itinerary, index) => (
              <div key={index} style={{
                background: 'white',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                overflow: 'hidden',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                transition: 'all 0.2s ease',
                ':hover': {
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  borderColor: '#d1d5db'
                }
              }}>
                {/* En-tête de l'itinéraire */}
                <div style={{
                  background: '#f0fdf4',
                  padding: '16px 20px',
                  borderBottom: '1px solid #e5e7eb',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '8px',
                      background: '#dcfce7',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#059669',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}>
                      {index + 1}
                    </div>
                    <div>
                      <div style={{ fontSize: '15px', fontWeight: '600', color: '#1f2937' }}>
                        {t('transfer')} {index + 1}
                      </div>
                      <div style={{ fontSize: '13px', color: '#6b7280' }}>
                        {itinerary.transferDate ? new Date(itinerary.transferDate).toLocaleDateString() : 'N/A'} • {itinerary.transferTime || 'N/A'}
                      </div>
                    </div>
                  </div>
                  <div style={{
                    fontSize: '13px',
                    color: '#059669',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    fontWeight: '500'
                  }}>
                    <Navigation size={12} />
                    {itinerary.travelType === 'flight' ? t('airportTransfer') : t('generalTransfer')}
                  </div>
                </div>

                {/* Corps de l'itinéraire */}
                <div style={{ padding: '20px' }}>
                  {/* Route visuelle */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px',
                    background: '#f9fafb',
                    borderRadius: '10px',
                    marginBottom: '20px',
                    border: '1px solid #e5e7eb',
                    position: 'relative'
                  }}>
                    {/* Point de départ */}
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        margin: '0 auto 12px',
                        boxShadow: '0 4px 6px rgba(16, 185, 129, 0.3)'
                      }}>
                        <MapPin size={20} />
                      </div>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                        {itinerary.origin?.name || 'N/A'}
                      </div>
                      <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                        {itinerary.origin?.type || ''}
                      </div>
                      <div style={{
                        fontSize: '11px',
                        color: '#10b981',
                        background: 'rgba(16, 185, 129, 0.1)',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        marginTop: '8px',
                        display: 'inline-block'
                      }}>
                        {t('pickup')}
                      </div>
                    </div>

                    {/* Ligne de route */}
                    <div style={{ flex: 2, padding: '0 20px', position: 'relative' }}>
                      <div style={{
                        height: '2px',
                        background: 'linear-gradient(90deg, #10b981 0%, #059669 100%)',
                        width: '100%',
                        position: 'relative'
                      }}>
                        <Car size={20} style={{
                          position: 'absolute',
                          top: '-10px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          color: '#10b981',
                          animation: 'drive 3s ease-in-out infinite'
                        }} />
                      </div>
                      <div style={{ textAlign: 'center', marginTop: '16px' }}>
                        <div style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          color: '#10b981',
                          background: 'white',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          display: 'inline-block',
                          border: '1px solid #bbf7d0'
                        }}>
                          {t('transferRoute')}
                        </div>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px' }}>
                          {itinerary.transferDate} • {itinerary.transferTime}
                        </div>
                      </div>
                    </div>

                    {/* Point d'arrivée */}
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      <div style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        margin: '0 auto 12px',
                        boxShadow: '0 4px 6px rgba(59, 130, 246, 0.3)'
                      }}>
                        <MapPin size={20} />
                      </div>
                      <div style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                        {itinerary.destination?.[0]?.name || 'N/A'}
                      </div>
                      <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                        {itinerary.destination?.[0]?.type || ''}
                      </div>
                      <div style={{
                        fontSize: '11px',
                        color: '#3b82f6',
                        background: 'rgba(59, 130, 246, 0.1)',
                        padding: '2px 8px',
                        borderRadius: '4px',
                        marginTop: '8px',
                        display: 'inline-block'
                      }}>
                        {t('dropoff')}
                      </div>
                    </div>
                  </div>

                  {/* Informations détaillées */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '16px'
                  }}>
                    {/* Informations véhicule */}
                    {itinerary.vehicle && (
                      <div style={{
                        background: 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)',
                        borderRadius: '10px',
                        padding: '16px',
                        border: '1px solid #ddd6fe'
                      }}>
                        <h4 style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          color: '#7c3aed',
                          margin: '0 0 12px 0',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}>
                          <CarFront size={14} />
                          {t('vehicleDetails')}
                        </h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('type')}:</span>
                            <span style={{ fontSize: '13px', fontWeight: '500', color: '#1f2937' }}>
                              {itinerary.vehicle.type}
                            </span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('brand')}:</span>
                            <span style={{ fontSize: '13px', fontWeight: '500', color: '#1f2937' }}>
                              {itinerary.vehicle.brand}
                            </span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('model')}:</span>
                            <span style={{ fontSize: '13px', fontWeight: '500', color: '#1f2937' }}>
                              {itinerary.vehicle.model}
                            </span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('luggageCapacity')}:</span>
                            <span style={{ fontSize: '13px', fontWeight: '500', color: '#7c3aed' }}>
                              {itinerary.vehicle.luggageCapacity} {t('bags')}
                            </span>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('passengerCapacity')}:</span>
                            <span style={{ fontSize: '13px', fontWeight: '500', color: '#10b981' }}>
                              {itinerary.vehicle.capacity} {t('persons')}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Informations horaires */}
                    <div style={{
                      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      border: '1px solid #bae6fd'
                    }}>
                      <h4 style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#0ea5e9',
                        margin: '0 0 12px 0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}>
                        <Clock size={14} />
                        {t('schedule')}
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('date')}:</span>
                          <span style={{ fontSize: '13px', fontWeight: '500', color: '#1f2937' }}>
                            {itinerary.transferDate ? new Date(itinerary.transferDate).toLocaleDateString() : 'N/A'}
                          </span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('time')}:</span>
                          <span style={{ fontSize: '13px', fontWeight: '500', color: '#1f2937' }}>
                            {itinerary.transferTime || 'N/A'}
                          </span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('travelType')}:</span>
                          <span style={{
                            fontSize: '13px',
                            fontWeight: '500',
                            color: itinerary.travelType === 'flight' ? '#3b82f6' : '#059669'
                          }}>
                            {itinerary.travelType === 'flight' ? t('flight') : t('other')}
                          </span>
                        </div>
                        {itinerary.travelNumber && (
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span style={{ fontSize: '12px', color: '#6b7280' }}>{t('travelNumber')}:</span>
                            <span style={{ fontSize: '13px', fontWeight: '500', color: '#7c3aed' }}>
                              {itinerary.travelNumber}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Points de transfert */}
                    <div style={{
                      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
                      borderRadius: '10px',
                      padding: '16px',
                      border: '1px solid #fcd34d'
                    }}>
                      <h4 style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#d97706',
                        margin: '0 0 12px 0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}>
                        <Navigation size={14} />
                        {t('locations')}
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        <div>
                          <div style={{ fontSize: '11px', color: '#92400e', marginBottom: '4px' }}>
                            {t('origin')}
                          </div>
                          <div style={{ fontSize: '13px', fontWeight: '500', color: '#1f2937' }}>
                            {itinerary.origin?.name || 'N/A'}
                          </div>
                          <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>
                            {itinerary.origin?.type || ''}
                          </div>
                        </div>
                        {/* <div style={{ textAlign: 'center' }}>
                          <ArrowBigDown size={20} color="#f59e0b" />
                        </div> */}
                        <div>
                          <div style={{ fontSize: '11px', color: '#92400e', marginBottom: '4px' }}>
                            {t('destination')}
                          </div>
                          <div style={{ fontSize: '13px', fontWeight: '500', color: '#1f2937' }}>
                            {itinerary.destination?.[0]?.name || 'N/A'}
                          </div>
                          <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>
                            {itinerary.destination?.[0]?.type || ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};